export const isConcessionRole = (role) =>
  String(role?.name || "")
    .trim()
    .toLowerCase() === "concesiones";

export function userConcessions(data) {
  if (!Array.isArray(data)) throw new Error("La respuesta de concesiones no es válida.");
  const codes = new Set();
  return data.flatMap((row) => {
    const code = String(row?.code ?? "").trim();
    const name = String(row?.name ?? "").trim();
    if (row?.type !== "PEAJE" || !name || !code || codes.has(code)) return [];
    codes.add(code);
    return [{ name, code }];
  });
}

export function userMore(value) {
  if (typeof value === "string") {
    try {
      return userMore(JSON.parse(value));
    } catch {
      return {};
    }
  }
  return value && typeof value === "object" && !Array.isArray(value) ? { ...value } : {};
}
